import type { ReactNode } from 'react';
import { Link, useInRouterContext } from 'react-router';

/**
 * Kontextlink in die Hilfe („Mehr dazu in der Hilfe“). `slug` ist der Dateiname eines Artikels unter
 * `content/help`, `anchor` optional der Anker einer Überschrift. Ein Test prüft, dass die Ziele existieren.
 * Außerhalb eines Routers (kleine Bausteine in Einzeltests) wird ein gewöhnlicher Link daraus.
 */
export function HelpLink({
  slug,
  anchor,
  children = 'Mehr dazu in der Hilfe',
}: {
  slug: string;
  anchor?: string;
  children?: ReactNode;
}) {
  const inRouter = useInRouterContext();
  const to = `/hilfe/${slug}${anchor === undefined ? '' : `#${anchor}`}`;
  return inRouter ? <Link to={to}>{children}</Link> : <a href={to}>{children}</a>;
}
